import { FC } from "react";
import { Handle, Position } from "react-flow-renderer";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { useStore, connect } from "src/store/connect";

interface DocumentValidationBlockProps {
  data: NodeData;
}

interface Field {
  title: string;
  value: string;
}

const DocumentValidationBlock: FC<DocumentValidationBlockProps> = ({
  data,
}) => {
  const classes = useStyles();
  const state = useStore();

  const getFields = (): Field[] => {
    let fields: Field[] = [];

    if (!data.validationInput) {
      return [
        {
          title: "Validación de Rostro",
          value: "desactivada",
        },
      ];
    }

    const faceValidationFieldValue = data.validationInput?.faceValidation
      .default
      ? "activada"
      : "desactivada";

    fields.push({
      title: "Validación de Rostro",
      value: faceValidationFieldValue,
    });

    return fields;
  };

  return (
    <div className={classes.root}>
      <Handle
        type="target"
        position={Position.Left}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={data.connectable}
      />
      <div
        className={`${
          !data.highlighted && state.simulationRunning ? classes.opacity : ""
        }`}
      >
        <Typography className={classes.title}>
          Validación de Documento
        </Typography>
        <Typography className={classes.subtitle}>
          Opciones de la validación
        </Typography>
        {getFields().map((field) => {
          return (
            <div className={classes.fieldContainer}>
              <span className={classes.fieldSeparator} />
              <Typography className={classes.labelVariable}>
                {field.title}:
              </Typography>
              <Typography
                className={`${classes.labelVariableValue} ${
                  !data.validationInput?.faceValidation.default
                    ? classes.fontWeightLight
                    : ""
                }`}
              >
                {` ${field.value}`}
              </Typography>
            </div>
          );
        })}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={false}
      />
    </div>
  );
};

export default connect(DocumentValidationBlock);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "259px",
    padding: "22px 10px 35px 26px",
    borderRadius: "8px",
    boxShadow: "0 2px 24px 0 rgba(0, 0, 0, 0.08)",
    border: "solid 1px #5E52F9",
    borderTopWidth: "12px",
    backgroundColor: "#fff",
    color: "#1D262C",
  },
  title: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "21px",
  },
  subtitle: {
    margin: "8px 0 28px 0",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    opacity: "0.57",
  },
  opacity: {
    opacity: 0.36,
  },
  label: {
    fontSize: "14px",
    fontWeight: 500,
    overflowWrap: "break-word",
  },
  labelVariable: {
    fontSize: "14px",
    fontWeight: 500,
    overflowWrap: "break-word",
  },
  labelVariableValue: {
    fontWeight: 600,
    gridColumn: "2",
    fontSize: "14px",
  },
  fontWeightLight: {
    fontWeight: 200,
  },
  variable: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0091ff",
    overflowWrap: "break-word",
  },
  fieldContainer: {
    display: "grid",
    alignItems: "center",
    gridTemplateColumns: "1fr 10fr",
    margin: "0 0 10px 0",
  },
  fieldSeparator: {
    width: "8px",
    height: "38px",
    borderRadius: "2.5px",
    backgroundColor: "#64DFEE",
  },
  labelEmpty: {
    fontSize: "14px",
    fontWeight: 400,
    color: "#445561",
  },
}));
